





















































import { Component, Prop, Vue } from 'vue-property-decorator';
import Unavailability from '@/models/unavailability/unavailability';
import UnavailabilityDay from '@/components/unavailability/UnavailabilityDay.vue';
import UnavailabilityForm from '@/components/unavailability/UnavailabilityForm.vue';
import Nullable from '@/types/nullable';

@Component({
  components: {
    UnavailabilityDay,
    UnavailabilityForm
  }
})
export default class UnavailabilityCalendar extends Vue {
  @Prop({ type: Array, default: [] }) public unavailability!: Unavailability[];

  private calendarValue: Date = new Date();
  private showUnavailabilityForm: boolean = false;
  private selectedUnavailability: Nullable<Unavailability> = null;
  private userFeedback: Nullable<string> = null;

  previous(){
    let newDate = new Date(this.calendarValue);
    newDate.setMonth(this.calendarValue.getMonth() - 1);
    this.calendarValue = newDate;
  }

  next(){
    let newDate = new Date(this.calendarValue);
    newDate.setMonth(this.calendarValue.getMonth() + 1);
    this.calendarValue = newDate;
  }

  get today(){
    return this.formatDateString(new Date());
  }

  get unavailabilitiesByDateString(){
    return this.unavailability.map(unavailability => {
      let item: any = {};

      item[this.formatDateString(new Date(unavailability.onDate))] = unavailability;

      return item;
    }).reduce((map, val) => {
      Object.keys(val).forEach(property => map[property] = val[property]);
      return map;
    }, {});
  }

  selectDate(e: any){
    // Cannot select dates that are less than 7 days in the future
    let givenDate: number = new Date(e.date).getTime();
    let cutOffDate: number = new Date(this.formatDateString(new Date())).getTime();

    if(givenDate - cutOffDate < 7 * 24 * 60 * 60 * 1000){
      this.showUserFeedback("Unavailability within 7 days of today is locked")
      return;
    }

    this.showUnavailabilityForm = true;
    this.selectedUnavailability = this.unavailabilitiesByDateString[`${e.year}-${String(e.month).padStart(2, '0')}-${String(e.day).padStart(2, '0')}`];
    if(!this.selectedUnavailability){
      this.selectedUnavailability = {
        onDate: `${e.year}-${String(e.month).padStart(2, '0')}-${String(e.day).padStart(2, '0')}`
      }
    }
  }

  onRemoveUnavailability(oldUnavailability: Unavailability){
    // Remove existing unavailability
    let existingIndex = this.unavailability.findIndex(x => `${new Date(x.onDate)}` == `${new Date(oldUnavailability.onDate)}`);
    if(existingIndex >= 0){
      this.unavailability.splice(existingIndex, 1);
    }

    this.showUnavailabilityForm = false;
  }

  onAddOrUpdateUnavailability(newUnavailabilities: Unavailability[]){
    newUnavailabilities.forEach(x => this.onRemoveUnavailability(x));

    // Add new unavailability
    if(newUnavailabilities.length > 0){
      this.unavailability.push(...newUnavailabilities);
    }

    this.showUnavailabilityForm = false;
  }

  get monthName(){
    return ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][this.calendarValue.getMonth()];
  }

  get calendarDateString(){
    return this.formatDateString(this.calendarValue);
  }

  formatDateString(date: Date){
    return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  }

  showUserFeedback(message: string){
    this.userFeedback = message;
  }

  hideUserFeedback(){
    this.userFeedback = null;
  }

  created(){
    this.calendarValue = new Date();
  }
}
